<div class="filter">
  <div class="left-section">
    <div class="search-section">
      @if(config.hasSearch) {
      <div class="search-text">
        <mat-form-field appearance="outline">
          <mat-label>{{ config.searchPlaceholder }}</mat-label>
          <mat-icon matTextPrefix style="position: relative; top: +0.33em">search</mat-icon>
          <input matInput type="search" [value]="searchText" (input)="onSearchChange($event)" />
        </mat-form-field>
      </div>
      }
      <div class="filter-buttons">
        @for (filter of config.filters; track filter.value) {
        <button [class.active]="selectedFilter === filter.value" (click)="selectFilter(filter.value)">
          {{ filter.label }}
        </button>
        }
      </div>
      @if(config.hasDateRange && selectedFilter === 'intervalo') {
      <div class="date">
        <span class="separator">|</span>
        <mat-form-field appearance="outline">
          <mat-date-range-picker #picker></mat-date-range-picker>
          <mat-label>Introduce un intérvalo</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="Fecha inicial" [ngModel]="startDate"
              (ngModelChange)="onDateRangeChange($event, endDate)" />
            <input matEndDate placeholder="Fecha final" [ngModel]="endDate"
              (ngModelChange)="onDateRangeChange(startDate, $event)" />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        </mat-form-field>
      </div>
      }
    </div>


  </div>
  <div class="paginator-container">
    <mat-paginator [pageSizeOptions]="config.paginatorOptions || [ 25, 50, 100]" aria-label="Select page of table"
      class="paginator-field"></mat-paginator>
  </div>
</div>